import { createContext, useState, useContext } from "react";

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [globalLoading, setGlobalLoading] = useState(false);

  return <LoadingContext.Provider value={{ globalLoading, setGlobalLoading }}>{children}</LoadingContext.Provider>;
};
